module.exports = __webpack_public_path__ + "img/PC_line_TW.b41c3cc5.png";